import moment from 'moment/moment'
export default {
  data() {
    return {
      datepicker: {
        options: {
          format: 'YYYY/MM/DD',
          useCurrent: false,
          icons: {
            clear: 'far fa-trash-alt',
            close: 'fas fa-times-circle',
          },
          showClear: true,
          showClose: true,
          locale: localStorage.getItem('lang'),
        },
      },
      timepicker: {
        options: {
          format: 'HH:mm',
          useCurrent: false,
          locale: localStorage.getItem('lang'),
        },
      },
      datetimepicker: {
        options: {
          format: 'YYYY/MM/DD HH:mm',
          useCurrent: false,
          icons: {
            clear: 'far fa-trash-alt',
            close: 'fas fa-times-circle',
            time: 'far fa-clock',
          },
          showClear: true,
          showClose: true,
          locale: localStorage.getItem('lang'),
        },
      },
    }
  },
  methods: {
    mixinTimestampToFormat(timestamp, format) {
      return moment.unix(timestamp).format(format)
    },
  },
}
